import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faCar,
  faDollarSign,
  faClock,
  faBoxes,
  faAddressCard,
  faClipboardList
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import "./UserMenu.css";

const DropdownItem = styled.div`
  padding: 5px 0;
  &:active {
    background-color: #808080 !important;
  }
  &:hover {
    background-color: #f8f9fa;
  }
  a.dropdown-item {
    display: inline-block;
    width: 50%;
    padding-left: 2px;
    color: #777;
    &:active {
      background-color: #fff;
    }
  }
`;
class StudentDropdown extends Component {
  render() {
    return (
      <div className="dropdown-menu appointment-menu">
        <Link to="/app/student-dashboard" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faDesktop} />
            Dashboard
          </DropdownItem>
        </Link>
        <Link to="/app/student-dashboard/basicinfo" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faAddressCard} />
            Basic Info
          </DropdownItem>
        </Link>

        <Link to="/app/student-dashboard/packages" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faBoxes} />
            Packages / Plans
          </DropdownItem>
        </Link>
        <Link to="/app/student-dashboard/payments" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faDollarSign} />
            Payment / Balances
          </DropdownItem>
        </Link>
        <Link to="/app/student-dashboard/lessons" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faCar} />
            Lessons
          </DropdownItem>
        </Link>
        <Link to="/app/student-dashboard/roadtests" className="dropdown-item">
          <DropdownItem>
            <FontAwesomeIcon icon={faClipboardList} />
            Road Tests
          </DropdownItem>
        </Link>
        <Link
          to="/app/student-dashboard/fivehourclass"
          className="dropdown-item"
        >
          <DropdownItem>
            <FontAwesomeIcon icon={faClock} />
            5hr. Class Info
          </DropdownItem>
        </Link>
      </div>
    );
  }
}

export default StudentDropdown;
